
import React from 'react';

const DownloadButton = ({
  label = 'Click Me',
  width = 'w-auto',
  bgColor = 'bg-blue-600',
  rounded = 'rounded-lg',
  textColor = 'text-white',
  hoverColor = 'hover:bg-blue-700',
  icon: Icon = null,
  onClick = () => { }
}) => {
  return (
    <div className="flex justify-center mt-12">
      <button onClick={onClick} className={`font-medium py-3 px-6 transition duration-300 flex items-center ${rounded} ${textColor}  ${bgColor} ${hoverColor} ${width}`}>  {Icon && <Icon className="h-5 w-5 mr-2" />}  {label}</button>
    </div>
  );
};

export default DownloadButton;
